import script from "./benefitsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./benefitsSection.vue?vue&type=script&setup=true&lang=js"

import "./benefitsSection.vue?vue&type=style&index=0&id=52cf0c5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52cf0c5d"]])

export default __exports__